import { render } from "./setDiffculty.vue?vue&type=template&id=2a12eb5c&scoped=true"
import script from "./setDiffculty.vue?vue&type=script&lang=js"
export * from "./setDiffculty.vue?vue&type=script&lang=js"

import "./setDiffculty.vue?vue&type=style&index=0&id=2a12eb5c&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a12eb5c"]])

export default __exports__